
    var riot = require('riot')
    //src: starling/src/tags/link-endpoint.html
riot.tag2('link-endpoint',
  '',
  'link-endpoint { opacity: 0; background: cyan; } link-endpoint:hover { background: magenta; } link-endpoint.active { display: block; }',
  'ref="main" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}" class="{this.hasNode() ? \'node-endpoint\' : \'free-endpoint\'} {this.isShowing ? \'active\' : \'\'}" riot-style="{getStyle()}"', function(opts) {
'use strict';

var _this = this;

var _relationshipUi = require('lib/relationship-ui');

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.instance = this.opts.instance;
this.canvas = this.opts.canvas;

this.canvas.linkEndPointTags[this.instance.id] = this;
this.dragging = false;

this._updatePosition = function () {
  var endPoint = _this.canvas.store.getEndPoint(_this.id);
  endPoint.updatePosition();
};

this.handleMouseEnter = function () {
  if (_this.canvas.dragging) return;
  var endPoint = _this.canvas.store.getEndPoint(_this.id);
  var linkTag = _this.canvas.linkTags[endPoint.linkId];
  linkTag.endpointHovered = true;
  linkTag.setHoveredState();
  linkTag.updateMarkerEnds();
  linkTag.shiftEnds();
};

this.handleMouseLeave = function () {
  var endPoint = _this.canvas.store.getEndPoint(_this.id);
  var linkTag = _this.canvas.linkTags[endPoint.linkId];
  linkTag.endpointHovered = false;
  if (!linkTag.isSelected()) {
    linkTag.resetEnds();
  }
  linkTag.clearHoverState();
  linkTag.updateMarkerEnds();
};

this.getRenderedX = function () {
  var endPoint = _this.canvas.store.getEndPoint(_this.id);
  var linkTag = _this.canvas.linkTags[endPoint.linkId];
  if (!linkTag) return 0;

  if (endPoint.direction == 'from') {

    return linkTag.instance.fromNodeId ? linkTag.fromEdgePoint.x : endPoint.x;
  } else {

    return linkTag.instance.toNodeId ? linkTag.toEdgePoint.x : endPoint.x;
  }
};

this.getRenderedY = function () {
  var endPoint = _this.canvas.store.getEndPoint(_this.id);
  var linkTag = _this.canvas.linkTags[endPoint.linkId];
  if (!linkTag) return 0;

  if (endPoint.direction == 'from') {

    return linkTag.instance.fromNodeId ? linkTag.fromEdgePoint.y : endPoint.y;
  } else {

    return linkTag.instance.toNodeId ? linkTag.toEdgePoint.y : endPoint.y;
  }
};

this.show = function () {
  _this.refs.main.classList.add("active");
  _this.isShowing = true;
};

this.hide = function () {
  _this.refs.main.classList.remove("active");
  _this.isShowing = false;
};

this.updatePositionDisplay = function () {
  var endPoint = _this.canvas.store.getEndPoint(_this.id);
  if (!_this.instance.link().showArc()) {
    _this.refs.main.style.display = 'none';
    return;
  }
  _this._updatePosition();
  _this.refs.main.style.display = '';
  _this.refs.main.style.left = _this.getRenderedX() + 'px';
  _this.refs.main.style.top = _this.getRenderedY() + 'px';
  if (_this.dragging) {
    _this.refs.main.style.pointerEvents = 'none';
  } else {
    _this.refs.main.style.pointerEvents = '';
  }
};

this.hasNode = function () {
  var endPoint = _this.canvas.store.getEndPoint(_this.id);
  if (endPoint.node()) return true;
  return false;
};

this.getStyle = function () {
  if (!_this.instance.link().showArc()) return 'display: none;';

  _this._updatePosition();
  if (_this.dragging) {
    return 'left: ' + _this.getRenderedX() + 'px; top: ' + _this.getRenderedY() + 'px; pointer-events: none;';
  }
  return 'left: ' + _this.getRenderedX() + 'px; top: ' + _this.getRenderedY() + 'px;';
};

this.on('mount', function () {
  _this.hide();
  _this.setupDragging();
});

this.setupDragging = function () {
  _this.dragger = (0, _interactjs2.default)(_this.refs.main).styleCursor(false).draggable({
    max: 3,
    maxPerElement: 3,
    onstart: _this.onMoveStart,
    onmove: _this.onMove,
    onend: _this.onMoveEnd
  });
};

this.onMoveStart = function (e) {
  _this.canvas.setLinkDragging(_this.instance.link().id);
  _this.canvas.setSelectedElements([canvas.linkTags[_this.instance.link().id]]);
  _relationshipUi.rui.setPrevLinkEndpoints({ link: _this.instance.link() });
  // todo: make linkNode pointer events none while dragging endpoint
};

this.onMove = function (_ref) {
  var dx = _ref.dx,
      dy = _ref.dy;

  var endPoint = _this.canvas.store.getEndPoint(_this.id);
  endPoint.setNodeId(0);

  var link = _this.instance.link();

  if (link.fromNodeId && endPoint.direction == 'from') {
    link.fromNodeId = 0;
    var edgePoint = canvas.linkTags[_this.instance.link().id].fromEdgePoint;
    endPoint.x = edgePoint.x;
    endPoint.y = edgePoint.y;
  }

  if (link.toNodeId && endPoint.direction == 'to') {
    link.toNodeId = 0;
    var _edgePoint = canvas.linkTags[_this.instance.link().id].toEdgePoint;
    endPoint.x = _edgePoint.x;
    endPoint.y = _edgePoint.y;
  }

  _this.canvas.endPointDragging = true;
  _this.dragging = true;

  var _canvas$getMatrix = canvas.getMatrix(),
      scale = _canvas$getMatrix.scale;

  dx = dx / scale;
  dy = dy / scale;
  _this._applyMove({ dx: dx, dy: dy });
  _this.update();
  _this.updatePositionDisplay();
  _this.updateLine();
};

this.onMoveEnd = function (e) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var endPoint = _this.canvas.store.getEndPoint(_this.id);
  var targetNode = _this.canvas.mouseEnteredNode || params.targetNode;

  if (targetNode) {
    var link = _this.instance.link();
    if (endPoint.direction == 'to') {
      link.toNodeId = targetNode.id;
    } else {
      link.fromNodeId = targetNode.id;
    }
    endPoint.setNodeId(targetNode.id);
    endPoint.gotoClosestEdge();
    endPoint.updatePosition();
  } else {
    endPoint.setNodeId(0);
  }
  _this.canvas.endPointDragging = false;
  _this.dragging = false;
  _this.canvas.setLinkDragging(false);

  _this.updateLine();
  _this.updatePositionDisplay();
  _this.update();
  _this.updateSiblingEndPoint();
  _relationshipUi.rui.updateEndpoints({ link: _this.instance.link() });
};

this.updateSiblingEndPoint = function () {
  var link = _this.canvas.store.getLink(_this.instance.linkId);
  var siblingEndPointId = _this.instance.direction == 'to' ? link.fromEndPoint.id : link.toEndPoint.id;
  var siblingTag = _this.canvas.linkEndPointTags[siblingEndPointId];
  siblingTag.updatePositionDisplay();
  siblingTag.update();
};

this._applyMove = function (_ref2) {
  var dx = _ref2.dx,
      dy = _ref2.dy;

  var endPoint = _this.canvas.store.getEndPoint(_this.id);
  endPoint.applyMove({ dx: dx, dy: dy });
};

this.updateLine = function () {
  var linkTag = _this.canvas.linkTags[_this.instance.linkId];
  linkTag._updatePosition();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('link-endpoint')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/link-endpoint.html
// module id = 800
// module chunks = 0